import { atom } from "recoil";

export const paymentStore = atom({
	key: "paymentStore",
	default: {
		show: false,
		loaded: false,
		statusLoaded: true,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		project: 1,
		data: [],
		deposits: [],
		withdrawals: [],
		selectedItems: [],
		sorting: {
			sortingColumn: {
				sortingField: "",
			},
			sortingDescending: false,
		},
		search: {
			deposit: {
				currentSearchType: "",
				currentSearch: "",
				currentOption: {
					type: false,
					order: false,
					direction: false,
				},
			},
			withdrawals: {
				currentSearchType: "",
				currentSearch: "",
				currentOption: {
					type: false,
					order: false,
					direction: false,
				},
			}
		},
		depositSort: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		withdrawalsSort: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			deposit: {
				total: 0,
				page: 0,
				perPage: 0,
				totalPage: 0,
			},
			withdrawals: {
				total: 0,
				page: 0,
				perPage: 0,
				totalPage: 0,
			},
		},
	},
});
